import React from 'react'
import { Pagination } from '../../../../../interfaces/pagination'

interface IProps extends Partial<Pagination> {
  compact?: boolean
}

export const LoadingAttendees = ({ limit = 3, compact }: IProps) => (
  <>
    {Array.from({ length: limit })
      .fill(null)
      .map((_, i) => `loading-row-${i}`)
      .map((key) => (
        <div key={key}>
          <hr className="my-3" />
          <div className="row">
            <div
              className={
                compact
                  ? 'col-10 col-sm-6 col-md-10 col-lg-6'
                  : 'col-10 col-sm-6 col-md-10 col-lg-6 col-xl-7'
              }
            >
              <div className="row g-0">
                <div className="col-3">
                  <div>
                    <div
                      className="row-img-square animate"
                      style={compact ? { height: 25, width: 25 } : undefined}
                    ></div>
                  </div>
                </div>
                <div className="col-9" style={{ height: compact ? 55 : 80 }}>
                  <div className="animate mx-3 rounded" style={{ height: compact ? 40 : 55 }} />
                </div>
              </div>
            </div>
            <div className="col-1 col-sm-5 col-md-1 col-lg-5" style={{ height: compact ? 55 : 80 }}>
              <div className="animate rounded" style={{ height: compact ? 40 : 55 }} />
            </div>
          </div>
        </div>
      ))}
  </>
)
